export const IDENTIFICATION_STATUS_KEY = "identificationStatus";

export const PI_FORM_STEP_ROUTES = ["/step/3", "/step/4"];

export function getPersistedIdentificationStatus() {
  return sessionStorage.getItem(IDENTIFICATION_STATUS_KEY) || "";
}

export function setPersistedIdentificationStatus(status) {
  if (status) {
    sessionStorage.setItem(IDENTIFICATION_STATUS_KEY, status);
  } else {
    sessionStorage.removeItem(IDENTIFICATION_STATUS_KEY);
  }
}

export function clearPersistedIdentificationStatus() {
  sessionStorage.removeItem(IDENTIFICATION_STATUS_KEY);
}
